<ng-container *ngIf="context$ | async as context">
    <ng-container *ngIf="context.breadcrumbs?.length">
        <nav class="breadcrumb-nav" aria-label="Ruta de navegación">
            <ol class="crumbs">
                <li class="ancestor-overflow" cdkOverlayOrigin #allOrigin="cdkOverlayOrigin">
                    <button type="button" class="overflow-trigger" aria-label="Ver ruta completa" aria-haspopup="dialog"
                            [attr.aria-expanded]="panelOpen && activeOrigin === allOrigin"
                            (click)="openPanel(null, allOrigin)">
                        <span aria-hidden="true">…</span>
                    </button>
                </li>
                <li *ngFor="let crumb of context.breadcrumbs; let index = index; trackBy: trackCrumb" class="crumb-item"
                    [class.period-crumb]="crumb.id === 'period'" [class.contract-crumb]="crumb.id === 'contract'"
                    [class.last-crumb]="index === context.breadcrumbs.length - 1"
                    [attr.data-crumb-id]="crumb.id"
                    [attr.aria-current]="index === context.breadcrumbs.length - 1 ? 'page' : null"
                    cdkOverlayOrigin #origin="cdkOverlayOrigin"
                    (mouseenter)="hoverDetails(crumb, origin)" (mouseleave)="leaveOrigin($event)">
                    <span *ngIf="index > 0" class="crumb-separator" aria-hidden="true">›</span>
                    <div class="crumb-card">
                        <span *ngIf="crumb.id === 'period'; else interactiveCrumb" class="crumb-main period-display">
                            <span class="crumb-label period-long">{{ crumb.label }}</span>
                            <span class="period-compact">{{ crumb.compactLabel || crumb.label }}</span>
                        </span>
                        <ng-template #interactiveCrumb>
                            <a *ngIf="crumb.link; else detailTrigger" class="crumb-main" [routerLink]="crumb.link">
                                <span *ngIf="crumb.label" class="crumb-label">{{ crumb.label }}</span>
                                <span *ngIf="crumb.subtitle" class="crumb-subtitle">{{ crumb.subtitle }}</span>
                                <span *ngIf="contractRp(crumb) as rp" class="crumb-subtitle">RP: {{ rp }}</span>
                            </a>
                            <ng-template #detailTrigger>
                                <button type="button" class="crumb-main" aria-haspopup="dialog"
                                        [attr.aria-label]="'Ver detalles de ' + title(crumb)"
                                        [attr.aria-expanded]="panelOpen && activeOrigin === origin"
                                        (click)="openPanel(crumb, origin)">
                                    <span *ngIf="crumb.label" class="crumb-label">{{ crumb.label }}</span>
                                    <span *ngIf="crumb.subtitle" class="crumb-subtitle">{{ crumb.subtitle }}</span>
                                    <span *ngIf="contractRp(crumb) as rp" class="crumb-subtitle">RP: {{ rp }}</span>
                                </button>
                            </ng-template>
                            <button *ngIf="crumb.link && crumb.details?.length" type="button" class="detail-trigger"
                                    aria-haspopup="dialog" [attr.aria-label]="'Ver detalles de ' + title(crumb)"
                                    [attr.aria-expanded]="panelOpen && activeOrigin === origin"
                                    (click)="openPanel(crumb, origin)">
                                <span aria-hidden="true">⌄</span>
                            </button>
                        </ng-template>
                    </div>
                </li>
            </ol>
        </nav>
        <ng-template cdk-connected-overlay [cdkConnectedOverlayOrigin]="activeOrigin"
                     [cdkConnectedOverlayOpen]="panelOpen" [cdkConnectedOverlayPositions]="panelPositions"
                     [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="8"
                     [cdkConnectedOverlayHasBackdrop]="!hoverOpened"
                     cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                     (backdropClick)="closePanel()" (overlayKeydown)="panelKeydown($event)">
            <section class="breadcrumb-panel bg-card text-default" role="dialog" [class.route-panel]="!activeCrumb"
                     [attr.aria-label]="activeCrumb ? 'Detalles de ' + title(activeCrumb) : 'Navegación'"
                     [attr.aria-modal]="!hoverOpened"
                     [cdkTrapFocus]="!hoverOpened" [cdkTrapFocusAutoCapture]="!hoverOpened"
                     (mouseleave)="leavePanel($event)">
                <header class="panel-heading">
                    <h2 *ngIf="activeCrumb">{{ title(activeCrumb) }}</h2>
                    <button type="button" class="detail-trigger" aria-label="Cerrar detalles" (click)="closePanel()">×
                    </button>
                </header>
                <ng-container *ngFor="let crumb of panelCrumbs(context)">
                    <a *ngIf="!activeCrumb && crumb.link; else detailSection" class="panel-crumb panel-link"
                       [routerLink]="crumb.link" (click)="closePanel()">
                        <ng-container *ngTemplateOutlet="panelContent; context: {$implicit: crumb}"></ng-container>
                    </a>
                    <ng-template #detailSection>
                        <section class="panel-crumb">
                            <ng-container *ngTemplateOutlet="panelContent; context: {$implicit: crumb}"></ng-container>
                        </section>
                    </ng-template>
                </ng-container>
                <ng-template #panelContent let-crumb>
                    <a *ngIf="activeCrumb && crumb.link; else panelLabel" [routerLink]="crumb.link"
                       (click)="closePanel()">{{ crumb.label }}</a>
                    <ng-template #panelLabel><strong>{{ crumb.label }}</strong></ng-template>
                    <p *ngIf="crumb.subtitle && !crumb.details?.length">{{ crumb.subtitle }}</p>
                    <dl *ngIf="crumb.details?.length">
                        <ng-container *ngFor="let detail of crumb.details">
                            <dt>{{ detail.label }}:</dt>
                            <dd>{{ detail.value }}</dd>
                        </ng-container>
                    </dl>
                </ng-template>
            </section>
        </ng-template>
    </ng-container>
</ng-container>
